export { default as LoadingSkeleton } from './component';
